import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions, auth } from '../firebase/config';
import { ArrowLeft, Loader2, Send } from 'lucide-react';

const PortalNewRequest = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ subject: '', description: '' });
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError('');

        const user = auth.currentUser;
        if (!user) return;

        try {
            // --- FIX START: Get the REAL Customer ID from the token ---
            const tokenResult = await user.getIdTokenResult();
            const orgId = tokenResult.claims.organizationId;
            const realCustomerId = tokenResult.claims.customerId; // <--- THIS IS THE FIX

            // Call the Cloud Function
            const createRequest = httpsCallable(functions, 'createNewQuoteRequest');
            
            await createRequest({
                orgId: orgId,
                customerId: realCustomerId, // Use the clean ID, not user.uid
                subject: formData.subject,
                description: formData.description
            });
            // --- FIX END ---

            // Success! Go back to list
            navigate('/portal/requests');

        } catch (err) {
            console.error("Error submitting request:", err);
            setError(err.message || 'We could not submit your request. Please try again later.');
            setSubmitting(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto">
            <button 
                onClick={() => navigate('/portal/requests')}
                className="flex items-center text-gray-500 hover:text-gray-800 transition-colors mb-6"
            >
                <ArrowLeft size={18} className="mr-1" /> Back to Requests
            </button>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="p-6 border-b border-gray-100 bg-gray-50">
                    <h1 className="text-2xl font-bold text-gray-900">New Work Request</h1>
                    <p className="text-gray-500 mt-1">Tell us what you need, and we'll get back to you with a quote.</p>
                </div>

                <div className="p-8">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Subject <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                required
                                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all"
                                placeholder="e.g., Spring Cleanup, Fence Repair"
                                value={formData.subject}
                                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                            />
                        </div>

                        <div className="mb-8">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Details <span className="text-red-500">*</span>
                            </label>
                            <textarea
                                required
                                rows={6}
                                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all"
                                placeholder="Describe the work you need done..."
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            />
                        </div>

                        {error && (
                            <div className="bg-red-50 text-red-600 p-4 rounded-md mb-6 text-sm">
                                {error}
                            </div>
                        )}

                        <div className="flex justify-end">
                            <button
                                type="submit"
                                disabled={submitting}
                                className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-md transition-colors shadow-sm flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {submitting ? <Loader2 className="animate-spin" /> : <Send size={18} />}
                                {submitting ? 'Sending...' : 'Send Request'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PortalNewRequest;